import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import { shufflaa } from '../../utils/randomize'
import { data } from './data/data_03_sauvojen_pituus.js'

// import kuva1 from './images/matala1.png'
// import kuva1 from './images/matala1_300x430.png'
import kuva1 from './images/matala1_400x700.png'
// import kuva2 from './images/matala2.png'
import kuva2 from './images/matala2_400x700.png'
// import kuva3 from './images/sopiva3.png'
import kuva3 from './images/sopiva3_400x700.png'
// import kuva4 from './images/yli4.png'
import kuva4 from './images/yli4_400x700.png'
import arrowUp from './images/arrowUp.png'
import arrowDown from './images/arrowDown.jpg'



const SauvojenPituus = ({ scoreHandler, visibilityHandler, soundsOn }) => {


    const [selectedImage, setSelectedImage] = useState(kuva1)

    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    const up = () => {
        if (selectedImage != kuva4) {
            if (selectedImage == kuva1) {
                setSelectedImage(kuva2)
            }
            else if (selectedImage == kuva2) {
                setSelectedImage(kuva3)
            }
            else {
                setSelectedImage(kuva4)
            }
        }

    }

    const down = () => {
        if (selectedImage != kuva1) {
            if (selectedImage == kuva4) {
                setSelectedImage(kuva3)
            }
            else if (selectedImage == kuva3) {
                setSelectedImage(kuva2)
            }
            else {
                setSelectedImage(kuva1)
            }
        }
    }

    const lukitse = () => {
        console.log(selectedImage);




        if (selectedImage.includes('sopiva')) {
            if (soundsOn) {
                playCorrectAnswer()
            }
            scoreHandler(data.optiot[2], data.scene, data.maxp)
            visibilityHandler(data.optiot[2].valinta)

        }
        else {
            if (soundsOn) {
                playWrongAnswer()
            }
            if (selectedImage.includes('matala1')) {
                scoreHandler(data.optiot[0], data.scene)
                visibilityHandler(data.optiot[0].valinta)
            }
            else if (selectedImage.includes('matala2')) {
                scoreHandler(data.optiot[1], data.scene)
                visibilityHandler(data.optiot[1].valinta)
            }
            else if (selectedImage.includes('yli4')) {
                scoreHandler(data.optiot[3], data.scene)
                visibilityHandler(data.optiot[3].valinta)
            }
        }





    }






    return (

        <div className='sceneContainer'>

            <div id='image' className='kuvaBox'>

                <img src={selectedImage} alt="kuva" />


            </div>

            <div id='question'>
                <h4>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h4>
            </div>

            <div id='actions'>
                <div className='smallBox'><img src={arrowUp} alt="up" onClick={() => up()} /></div>
                <div className='smallBox'><img src={arrowDown} alt="down" onClick={() => down()} /></div>

                <button onClick={() => lukitse()}>Lukitse vastaus</button>


            </div>
        </div>
    )

}

export default SauvojenPituus